import { countryDictionary } from "../untils/dictionary";
import { t } from "./userHelper";

export const euCountryCodes = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
] as const;

const euCountryCodeSet = new Set<string>(euCountryCodes);

export const isEuCountry = (code: string): boolean => {
  if (!code) {
    return false;
  }
  return euCountryCodeSet.has(code.toUpperCase());
};

export const getCountryScopeByLang = (langCode: string) => {
  const langKey = langCode.toLowerCase() as "pl" | "en";

  return Object.entries(countryDictionary)
    .map(([value, labels]) => ({
      value,
      label: labels[langKey],
    }))
    .sort((a, b) => a.label.localeCompare(b.label, langKey));
};

export const countryScope = Object.entries(countryDictionary).map(
  ([value, label]) => ({
    value,
    label: t(label),
  }),
);

export const setCountryMode = (countryCode: string) => {
  if (countryCode.toLocaleLowerCase() === "pl") {
    return "pl";
  } else if (isEuCountry(countryCode)) {
    return "eu";
  }
  return "other";
};
